import { createContext, useContext, type ReactNode } from 'react';

// A message the card answers, as the collapsed context line quotes it
export type ContextSource = { author: string; text: string };

export type HostContextPeek = {
  // Drawn in the Reason's place, given the reason text the document resolved: the card's context line, which opens
  // to the full reason and its sources
  line: (reason: string | null) => ReactNode;
  // Where the messages the card answers render, inside the opened context line
  sourceTarget: HTMLElement | null;
  // Adds a source message while it is shown; returns its removal
  registerSource: (source: ContextSource) => () => void;
};

// Set by a host that keeps the card's reason and the messages it answers in a context line that opens and closes
export const HostContextPeekContext = createContext<HostContextPeek | null>(
  null
);

export const useHostContextPeek = () => useContext(HostContextPeekContext);
